module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.playerOptions) ? _c('RecordPlayer', {
    ref: "playerComponent",
    attrs: {
      "options": _vm.playerOptions,
      "size-styles": {
        width: '100%',
        height: '400px'
      }
    },
    on: {
      "timeupdate": _vm.playerTimeUpdateHandler,
      "pause": function($event) {
        _vm.playing = false
      },
      "ended": function($event) {
        _vm.playing = false
      },
      "playing": function($event) {
        _vm.playing = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "slider",
    staticClass: "cut-slider"
  }, [_c('div', {
    staticClass: "frames"
  }, _vm._l((_vm.frames), function(frame, index) {
    return _c('div', {
      key: index,
      style: ([_vm.frameStyle, frame])
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mask left",
    style: (_vm.leftMaskStyle)
  }), _vm._v(" "), _c('div', {
    ref: "leftControl",
    staticClass: "controller left",
    style: (_vm.leftControlStyle),
    on: {
      "mousedown": _vm.dragLeftControlStart,
      "touchstart": _vm.dragTouchLeftControlStart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "active-section",
    on: {
      "click": _vm.setRunnerPos
    }
  }, [(_vm.showControlTime) ? _c('div', {
    staticClass: "left"
  }, [_vm._v("\n        " + _vm._s(_vm.leftControlVideoPositionFormatted) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-duration"
  }, [_vm._v(_vm._s(_vm.videoSectionDurationFormatted))]), _vm._v(" "), (_vm.showControlTime) ? _c('div', {
    staticClass: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.rightControlVideoPositionFormatted) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "rightControl",
    staticClass: "controller right",
    style: (_vm.rightControlStyle),
    on: {
      "mousedown": _vm.dragRightControlStart,
      "touchstart": _vm.dragTouchRightControlStart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mask right",
    style: (_vm.rightMaskStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "runner",
    style: (_vm.runnerStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "btn-primary play-btn",
    attrs: {
      "flat": "",
      "fab": ""
    },
    on: {
      "click": _vm.playRange
    }
  }, [(_vm.playing) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("pause")]) : _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("play_arrow")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75c5f7a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/RecordCutSlider.vue
// module id = 1058
// module chunks = 1